import { render } from "./EmbudoProduccion.vue?vue&type=template&id=a3bd0b0e"
import script from "./EmbudoProduccion.vue?vue&type=script&lang=js"
export * from "./EmbudoProduccion.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__